import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Select from "react-select";
import Header from "components/Headers/Header";

const CreaAprobadorTecnico = () => {
  const [postVariable, setPostVariable] = useState([]);
  const [postArea, setPostArea] = useState([]);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);

  useEffect(() => {
    axios
      .get("https://contratosback.azurewebsites.net/api/v1/ObtenerUsuarios")
      .then((Response) => {
        const apiOptions = Response.data.map((item) => ({
          value: item.id,
          label: item.nombre,
        }));
        setOptions(apiOptions);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    axios
      .get("https://contratosback.azurewebsites.net/api/v1/ObtenerAreas")
      .then((Response) => {
        const apiOptions1 = Response.data.map((item) => ({
          value: item.id,
          label: item.nombreArea,
        }));
        setOptions1(apiOptions1);
      })
      .catch((error) => console.log(error));
  }, []);

  const postData = (e) => {
    e.preventDefault();
    axios
      .post(
        "https://contratosback.azurewebsites.net/api/v1/CrearAprobadorTecnico",
        {
          areas: postArea.value,
          usuarioId: postVariable.value,
        },
      )
      .then(() => {
        alert("Creada con éxito!");
        setIsOpen(false);
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear " + error);
      });
  };

  return (
    <>
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Button color="primary" onClick={() => setIsOpen(true)}>
                  Añadir nuevo técnico
                </Button>
              </CardHeader>
              <CardBody>
                <ReactModal
                  isOpen={modalIsOpen}
                  onRequestClose={() => setIsOpen(false)}
                >
                  <Header />
                  <Form>
                    <FormGroup>
                      <label>Seleccione el usuario</label>
                      <Select options={options} onChange={setPostVariable} />
                    </FormGroup>
                    <FormGroup>
                      <label>Seleccione el Área</label>
                      <Select options={options1} onChange={setPostArea} />
                    </FormGroup>
                    <Button color="success" onClick={postData}>
                      ENVIAR
                    </Button>
                    <Button color="danger" onClick={() => setIsOpen(false)}>
                      Cerrar
                    </Button>
                  </Form>
                </ReactModal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreaAprobadorTecnico;
